'use client';

import { HTMLProps } from '@/lib/util/types';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';

export type ClockProps = {} & HTMLProps<HTMLDivElement>;

function formatTime(date: Date) {
  const homeTimeZone = 'Europe/Zurich';

  // TODO: Adapt this to current language
  return date.toLocaleTimeString('en-US', {
    timeZone: homeTimeZone,
    timeStyle: 'short',
  });
}

const Clock: React.FC<ClockProps> = ({ style, ...props }) => {
  const t = useTranslations('layout.footer.clock');

  const [localTime, setLocalTime] = useState<Date>();

  useEffect(() => {
    setLocalTime(new Date());
    const handle = setInterval(() => {
      setLocalTime(new Date());
    }, 5000);

    return () => {
      clearInterval(handle);
    };
  }, []);

  return (
    <div style={{ display: 'flex', gap: '1em', ...style }} {...props}>
      <span>{t('caption')}</span>
      <span style={{ fontWeight: 'bold' }}>{localTime ? formatTime(localTime) : 'Loading...'}</span>
    </div>
  );
};

export default Clock;
